@if (enabled()) {
  @let summary = trend();
  <section class="px-6 py-4" data-testid="bucket-trend">
    @if (!summary) {
      <p class="m-0 text-sm text-text-muted">{{ reportQuery.isPending() ? 'Loading history…' : 'History builds as months pass' }}</p>
    } @else {
      @if (futureNote(); as note) {
        <p class="m-0 mb-3 text-sm text-text-muted" data-testid="bucket-trend-future">{{ note }}</p>
      }
      <dl class="m-0 grid grid-cols-3 gap-x-4">
        @for (stat of stats(); track stat.label) {
          <div class="min-w-0">
            <dt class="truncate text-xs font-extrabold uppercase tracking-[0.04em] text-text-muted">{{ stat.label }}</dt>
            <dd class="m-0 mt-0.5 text-lg font-black tabular-nums text-text-title">
              {{ stat.value === null ? '—' : (stat.value | currency: 'USD' : 'symbol' : '1.0-0') }}
            </dd>
          </div>
        }
      </dl>

      <div class="mt-4">
        @defer {
          <app-bucket-trend-chart [rows]="summary.chartRows" />
        } @placeholder {
          <div class="h-[150px]" aria-hidden="true"></div>
        }
      </div>

      <details class="mt-2">
        <summary class="cursor-pointer text-xs font-bold text-text-link">Show the numbers</summary>
        <table class="mt-1 w-full text-xs tabular-nums" data-testid="bucket-trend-table">
          <caption class="sr-only">Spent versus budgeted, last six months</caption>
          <thead>
            <tr class="text-left text-text-muted">
              <th scope="col" class="py-1 font-bold">Month</th>
              <th scope="col" class="py-1 text-right font-bold">Spent</th>
              <th scope="col" class="py-1 text-right font-bold">Budgeted</th>
            </tr>
          </thead>
          <tbody>
            @for (row of summary.chartRows; track row.monthYear) {
              <tr class="border-t border-border-muted">
                <th scope="row" class="py-1 text-left font-semibold text-text-title">{{ monthName(row.monthYear) }}</th>
                <td class="py-1 text-right">{{ row.spent | currency: 'USD' : 'symbol' : '1.2-2' }}</td>
                <td class="py-1 text-right">
                  {{ row.budgeted === null ? '—' : (row.budgeted | currency: 'USD' : 'symbol' : '1.2-2') }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </details>

      @if (charges().length > 0) {
        <h3 class="m-0 mt-4 text-xs font-extrabold uppercase tracking-[0.04em] text-text-muted">Bills still to come</h3>
        <ul class="m-0 mt-1 list-none space-y-1 p-0" data-testid="bucket-trend-bills">
          @for (charge of charges(); track charge.recurringTransactionId + charge.expectedDate) {
            <li class="flex items-center justify-between gap-3 text-sm">
              <span class="min-w-0 truncate text-text-title">{{ charge.name }}</span>
              <span class="shrink-0 tabular-nums text-text-muted">
                {{ charge.expectedDate | date: 'MMM d' : 'UTC' }} ·
                <span class="font-bold text-text-title">{{ charge.amount | currency: 'USD' : 'symbol' : '1.2-2' }}</span>
              </span>
            </li>
          }
        </ul>
      }
    }
  </section>
}
